import { CategoryCode, SubCategoryCode, FeatureType, } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { combineMapKey, getFeatureData } from 'config-request';
import { useFeatureListStore } from './feature-list';
import { useGlobalStore } from './global';
export const useBatteryStore = defineStore('battery', {
    getters: {
        /**
         * 电池容量
         */
        batteryVolume() {
            const featureList = useFeatureListStore();
            const global = useGlobalStore();
            if (!featureList.data)
                return null;
            const pathArr = [
                CategoryCode.VersionBattery,
                SubCategoryCode.Battery,
                FeatureType.BatteryVolume,
            ];
            const batteryData = getFeatureData(pathArr, featureList.data);
            if (batteryData) {
                const options = batteryData.option_list
                    ?.map((option) => featureList.data?.option_map[option])
                    .filter((option) => !global.currentHideOptions.includes(option?.code ?? ''))
                    .map((option) => {
                    const combineData = featureList.data?.option_combine_map[combineMapKey(option?.code ?? '', global.currentOptions.F00029)] ?? {};
                    return {
                        ...option,
                        ...combineData,
                        optionDesc: option?.desc,
                    };
                });
                return {
                    options,
                    batteryData,
                };
            }
        },
        /**
         * 电池购买类型
         */
        batteryPurchaseType() {
            const featureList = useFeatureListStore();
            const global = useGlobalStore();
            if (!featureList.data)
                return null;
            const pathArr = [
                CategoryCode.VersionBattery,
                SubCategoryCode.Battery,
                FeatureType.BatteryPurchaseType,
            ];
            const batteryPurchaseData = getFeatureData(pathArr, featureList.data);
            if (batteryPurchaseData) {
                const options = batteryPurchaseData.option_list
                    ?.map((option) => featureList.data?.option_map[option])
                    .map((option) => {
                    const combineData = featureList.data?.option_combine_map[combineMapKey(global.currentOptions.F00019, option?.code ?? '')] ?? {};
                    console.log('combineData', featureList.data?.option_combine_map, combineMapKey(global.currentOptions.F00019, option?.code ?? ''));
                    return {
                        ...option,
                        ...combineData,
                    };
                });
                return {
                    options,
                    batteryPurchaseData,
                };
            }
        },
        /**
         * 电池里程数量
         */
        mileage() {
            const global = useGlobalStore();
            const featureList = useFeatureListStore();
            if (!featureList.data)
                return null;
            const combineData = featureList.data.option_combine_map[combineMapKey(global.currentOptions.F00019, global.currentOptions.F00003)];
            if (combineData) {
                return {
                    mileage: combineData.mileage,
                    mileageUnit: combineData.mileage_unit,
                    mileageDesc: combineData.mileage_desc,
                    mileageTipDesc: combineData.tip_desc,
                    mileageTitle: combineData.tip_title,
                };
            }
            return {
                mileage: 0,
                mileageUnit: undefined,
                mileageDesc: undefined,
                mileageTipDesc: undefined,
                mileageTitle: undefined,
            };
        },
        /**
         * 电池里程map
         */
        mileageMap() {
            const global = useGlobalStore();
            const featureList = useFeatureListStore();
            const result = {};
            if (!featureList.data)
                return null;
            const pathArr = [
                CategoryCode.VersionBattery,
                SubCategoryCode.Battery,
                FeatureType.BatteryVolume,
            ];
            const batteryData = getFeatureData(pathArr, featureList.data);
            if (batteryData) {
                batteryData.option_list?.forEach((option) => {
                    if (!option)
                        return;
                    const combineData = featureList.data?.option_combine_map[combineMapKey(option, global.currentOptions.F00003)];
                    if (combineData) {
                        result[option] = {
                            mileage: combineData.mileage,
                            mileageUnit: combineData.mileage_unit,
                            mileageDesc: combineData.mileage_desc,
                            mileageTipDesc: combineData.tip_desc,
                            mileageTitle: combineData.tip_title,
                            fullMileageDesc: `${combineData.mileage}${combineData.mileage_unit} ${combineData.mileage_desc}`,
                        };
                    }
                    else {
                        result[option] = {
                            mileage: 0,
                            mileageUnit: undefined,
                            mileageDesc: undefined,
                            mileageTipDesc: undefined,
                            mileageTitle: undefined,
                            fullMileageDesc: undefined,
                        };
                    }
                });
            }
            return result;
        },
        /**
         * 去了解跳转链接
         */
        aboutDescUrl() {
            const globalStore = useGlobalStore();
            const featureList = useFeatureListStore();
            const option = featureList.data?.option_map[globalStore.currentOptions.F00029];
            return option?.detail_desc_url;
        },
        /**
         * 组合版本
         */
        currentBatteryCombine() {
            const global = useGlobalStore();
            const featureList = useFeatureListStore();
            if (!featureList.data)
                return null;
            const combineData = featureList.data.option_combine_map[combineMapKey(global.currentOptions.F00019, global.currentOptions.F00029)];
            return {
                name: combineData?.name ?? '',
                price: combineData?.price ?? '',
            };
        },
        /**
         * 文案内容
         */
        cases() {
            return {
                batteryName: this.batteryVolume?.batteryData.name,
                batteryUrl: this.batteryVolume?.batteryData.detail_desc_url,
                purchaseTypeName: this.batteryPurchaseType?.batteryPurchaseData.name,
                purchaseTypeUrl: this.batteryPurchaseType?.batteryPurchaseData.detail_desc_url,
            };
        },
    },
});
